module.exports = __webpack_public_path__ + "img/Magnuss65.37354204.jpg";